import { render, staticRenderFns } from "./phoenix-landing-page.vue?vue&type=template&id=0c6811ec"
import script from "./phoenix-landing-page.vue?vue&type=script&lang=js"
export * from "./phoenix-landing-page.vue?vue&type=script&lang=js"
import style0 from "./phoenix-landing-page.vue?vue&type=style&index=0&id=0c6811ec&prod&lang=scss&module=%24s"




function injectStyles (context) {
  
  this["$s"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports